export default __webpack_public_path__ + "static/media/pvilla4-3.070fa375.jpg";